export default __webpack_public_path__ + "static/media/openness2Img1.c9abb38f.png";